import { render } from "./quiz-module-preview.vue?vue&type=template&id=4e6ceb92"
import script from "./quiz-module-preview.vue?vue&type=script&lang=js"
export * from "./quiz-module-preview.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__